
import { Options, Vue } from 'vue-class-component';
import axios from 'axios';
import Spinner from '@/loaders/spinner.vue';

const api = process.env.API_URL || './api/profile.json';

@Options({
  props: {
    msg: String,
    msgSpinner: { type: String },
  },
  components: { Spinner },
  computed: {},
  methods: {
    isLoading() {
      this.isLoading = true;
    },
  },
  data() {
    return {
      setProfile: [],
    };
  },
  mounted() {
    axios
      .get(api, { timeout: 5000 })
      .then((response) => {
        this.status = response.status;
        this.setProfile = response.data;
        if (this.status === 200) {
          if (!this.setProfile) {
            this.isLoading = true;
          }
        } else {
          throw new Error('An error has occured');
        }
      }).catch((Error) => Error);
    this.isLoading = false;
  },
})
export default class Welcome extends Vue {}
